import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from '../../core/services/utility/utility.service';

import { SubscriptionLike as ISubscription } from 'rxjs';
import { UserProfileService } from '../user-profile/user-profile.service';
import { NgIf } from '@angular/common';
@Component({
    selector: 'app-oss',
    templateUrl: './oss.component.html',
    styleUrls: ['./oss.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf],
})
export class OssComponent implements OnInit {

  public ossSafe: SafeResourceUrl;
  public ossLinkName: String = "";
  public ticketID: null;
  screenWidth: number;
  private subscriptions: ISubscription[];
  constructor(public sanitizer: DomSanitizer,
    private router: Router,
    private route: ActivatedRoute,
    private utilityService: UtilityService,
    private userProfileService: UserProfileService,
    private cdr: ChangeDetectorRef
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() { 
    this.subscriptions =[];
    this.route.queryParams.subscribe(params => {
      if (params['ticketId']) {
        this.ticketID = params['ticketId'];
        this.ossLinkName = "AOS Ticket Detail";
        this.subscriptions.push(this.userProfileService.getOSSLink("AOS Ticket Detail").subscribe(data => {
          this.ossSafe = this.sanitizer.bypassSecurityTrustResourceUrl(data.linkURL + "&ticketId=" + this.ticketID);
          this.cdr.markForCheck();
        }));
      }
      else if (params['ossLinkName']) {
        this.ossLinkName = params['ossLinkName'];
        this.subscriptions.push(this.userProfileService.getOSSLink(params['ossLinkName']).subscribe(data => {
          this.ossSafe = this.sanitizer.bypassSecurityTrustResourceUrl(data.linkURL);
          this.cdr.markForCheck();
        }));
      }
    });
  }
  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }
}
